var React = require('react');

function HamburgerInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 1.75C0 0.783502 0.783502 0 1.75 0H23.25C24.2165 0 25 0.783502 25 1.75C25 2.7165 24.2165 3.5 23.25 3.5H1.75C0.783502 3.5 0 2.7165 0 1.75Z","fill":"var(--color-text-3)","key":0}),React.createElement("path",{"d":"M0 10.75C0 9.7835 0.783502 9 1.75 9H23.25C24.2165 9 25 9.7835 25 10.75C25 11.7165 24.2165 12.5 23.25 12.5H1.75C0.783502 12.5 0 11.7165 0 10.75Z","fill":"var(--color-text-3)","key":1}),React.createElement("path",{"d":"M4 19.75C4 18.7835 4.7835 18 5.75 18H23.25C24.2165 18 25 18.7835 25 19.75C25 20.7165 24.2165 21.5 23.25 21.5H5.75C4.7835 21.5 4 20.7165 4 19.75Z","fill":"var(--color-text-3)","key":2})]);
}

HamburgerInline.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 25 22","fill":"none"};

module.exports = HamburgerInline;

HamburgerInline.default = HamburgerInline;
